import clsx from 'clsx';

const SHARED_LIST_CLASSES = clsx('list-block', 'space-y-1.5');

export default function ListBlock(props: any) {
  const {children, type} = props;

  const section = (list: any) => (
    <div className={'block-block my-6'}>
      <div className={clsx('container')}>{list}</div>
    </div>
  );

  if (type === 'bullet') {
    return section(<ul className={SHARED_LIST_CLASSES}>{children}</ul>);
  }

  if (type === 'number') {
    return section(<ol className={SHARED_LIST_CLASSES}>{children}</ol>);
  }

  return null;
}
